var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChipMonacoNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94401 18.6175C5.6156 18.6175 4.43932 18.3838 3.41518 17.9125C2.39104 17.4412 1.58954 16.7659 1.00697 15.8828C0.428104 14.9996 0.138672 13.9569 0.138672 12.7473V12.2946H3.36323V12.6471C3.36323 13.5896 3.68977 14.3391 4.34656 14.9032C5.00334 15.4672 5.86792 15.7455 6.9403 15.7455C8.01268 15.7455 8.87726 15.4857 9.47097 14.9625C10.0684 14.443 10.3652 13.7863 10.3652 12.9959V12.7436C10.3652 12.2055 10.2317 11.7677 9.96077 11.4337C9.69361 11.0997 9.32996 10.8511 8.87726 10.6916C8.42456 10.532 7.91249 10.4504 7.34105 10.4504H3.81222V6.92154L9.50807 3.89736V3.4929H0.587664V0.62085H13.0851V4.90295L7.76778 7.72675V8.13122H8.69915C9.48952 8.13122 10.2576 8.29077 11.0035 8.60989C11.7493 8.929 12.369 9.41881 12.8551 10.083C13.3412 10.7472 13.5861 11.6081 13.5861 12.6656V12.9699C13.5861 14.1128 13.3078 15.1072 12.7549 15.957C12.202 16.8067 11.4228 17.4598 10.4246 17.9236C9.42644 18.3838 8.2613 18.6175 6.93288 18.6175H6.94401Z",
    fill: "url(#paint0_linear_3716_18324)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3716_18324",
    x1: 6.86609,
    y1: -4.29948,
    x2: 6.86609,
    y2: 24.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#230135"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipMonacoNumber);
export default __webpack_public_path__ + "static/media/chip-monaco-number.70dd49f349d8fe038099c89866af8641.svg";
export { ForwardRef as ReactComponent };